import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, NEVER, Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { CandidateModel, PillModel } from '@shared/models';
import { SessionStorageService, QueryCollectorService, UserService } from '@shared/services';

import { environment } from '../../environments/environment';

interface CandidatesResponseModel {
  data: CandidateModel[];
}

@Injectable({
  providedIn: 'root'
})
export class CandidatesService {
  WORKER_SUGGESTIONS_API: string = `api/tc/v1/worker_suggestions`;

  private candidatesSubject = new BehaviorSubject<CandidateModel[]>(null);
  candidates = this.candidatesSubject.asObservable();

  private companyNumberSelected: number;
  loading:                       boolean;
  constructor(
    private http:                  HttpClient,
    private userService:           UserService,
    private queryCollectorService: QueryCollectorService,
    private sessionStorageService: SessionStorageService
  ) { this.init(); }

  private init(): void {
    if (this.userService.currentUserValue.isCustomer) {
      this.userService.authorizedForTemptonConnect.subscribe(isAuthorized => {
        if (isAuthorized) this.startCandidatesFetch();
      });
    }
  }

  getTemptonConnectCandidatePage(candidate: CandidateModel): { url: string, companyNumber: number, userId: number } {
    let activeCompany = this.sessionStorageService.activePills[0];
    let companyNumber = activeCompany?.company_number;
    let gid           = activeCompany?.gid
    return {
      url: `${environment.temptonConnectUrl}/kunde/vorschlaege/${candidate.worker_id}?customer_id=${gid}`,
      companyNumber,
      userId: this.userService.currentUserValue.id
    };
  }

  private companySelectedHasChanged(pills: PillModel[]): boolean {
    const nextSelected = pills.find(pill => pill.active)?.company_number ?? null;
    if (this.companyNumberSelected === nextSelected) return false;
    this.companyNumberSelected = nextSelected;
    return true;
  }

  private startCandidatesFetch(): void {
    this.sessionStorageService.pills.pipe(
      switchMap(pills => this.requestCandidates(pills))
    ).subscribe();
  }

  private requestCandidates(pills: PillModel[]): Observable<CandidateModel[]> {
    if (!this.companySelectedHasChanged(pills)) return NEVER;
    this.loading = true;
    return this.http.get<CandidatesResponseModel>(`${this.WORKER_SUGGESTIONS_API}${this.queryCollectorService.getCandidatesQuery()}`).pipe(
      map(res => res?.data || []),
      tap(candidates => this.candidatesSubject.next(candidates)),
      tap(() => this.loading = null)
    );
  }

}
